module.exports = __webpack_public_path__ + "spotlight1.19c0cf3695db4e2886389ea75ff47eb3.png";